module.exports = __webpack_public_path__ + "img/5.8adf79df.jpg";